import { render, staticRenderFns } from "./TypeTag.vue?vue&type=template&id=6fcf5af4&scoped=true"
import script from "./TypeTag.vue?vue&type=script&lang=js"
export * from "./TypeTag.vue?vue&type=script&lang=js"
import style0 from "./TypeTag.vue?vue&type=style&index=0&id=6fcf5af4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf5af4",
  null
  
)

export default component.exports